import { IUseWidgetByType, IWidgetBase, WidgetType, KpiDataId } from '../Metrics.model';
import { IDualKPIWidget } from '../../../components/Molecules/DualKpiWidget/DualKPIWidget.types';
import { IKPIWidget, Unit } from '../../../components/Molecules/KpiWidget/KPIWidget.types';
import DualKPIWidget from '../../../components/Molecules/DualKpiWidget/DualKPIWidget';
import KPIWidget from '../../../components/Molecules/KpiWidget/KPIWidget';
import useWidgetIconById from './useWidgetIconById';
import { mapMetricDataToDualKpiData } from '../Metrics.utils';
import LineChartWidget, { ILineChartWidgetProps } from '../../../components/Organisms/LineChartWidget';
import LocationFilter from '../../locations/components/LocationFilter/LocationFilter';
import { LINE_CHART_CONFIGS } from '../Metrics.config';


const useWidgetByType = ({ metricData, metricId, animate, type, previous, isLoading, error, hasLocationFilter }: IUseWidgetByType) => {
  const icon = useWidgetIconById(metricId);

  const baseProps: IWidgetBase = {
    title: metricData?.label || '',
    animated: animate || false,
    infoMessage: metricData?.description || '',
    isLoading: isLoading,
    error: error,
  };

  switch (type) {
    case WidgetType.KPI: {
      const value = metricData?.kpi.find(kpi => kpi.id === KpiDataId.TOTAL_CURRENT)?.value as number;
      const unit = metricData?.kpi.find(kpi => kpi.id === KpiDataId.TOTAL_CURRENT)?.unit as Unit;
      const kpiProps: IKPIWidget = {
        ...baseProps,
        value: value,
        unit: unit,
        compare: previous,
        compareValue: metricData?.kpi.find(kpi => kpi.id === KpiDataId.TOTAL_PREVIOUS)?.value,
        infoMessage: metricData?.description || '',
        icon: icon,
      };
      return <KPIWidget {...kpiProps}></KPIWidget>;
    }

    case WidgetType.DUAL_KPI: {
      const dualKpiProps: IDualKPIWidget = {
        ...baseProps,
        data: metricData?.kpi ? mapMetricDataToDualKpiData(metricData?.kpi) : undefined,
      };
      return <DualKPIWidget {...dualKpiProps}></DualKPIWidget>;
    }
    case WidgetType.LINE_CHART: {
      const lineChartProps: ILineChartWidgetProps = {
        ...baseProps,
        unit: metricData?.breakdown?.unit,
        data: metricData?.breakdown?.values ?? [],
        header: hasLocationFilter ? <LocationFilter /> : undefined,
        config: LINE_CHART_CONFIGS[metricId],
      };
      return <LineChartWidget {...lineChartProps} />;
    }
  }
};
export default useWidgetByType;
